import { useState } from 'react'
import { FormInput, FormSelect } from '../../shared/components/Fieldset'
import Pagination from '../../shared/components/Pagination'
import { useTranslation } from 'react-i18next'

const CardGrid = ({ data, renderCard, itemsPerPage = 30, filters = [] }) => {
    const [currentPage, setCurrentPage] = useState(1)
    const [searchQuery, setSearchQuery] = useState('')
    const [activeFilters, setActiveFilters] = useState({})
    const { t } = useTranslation()

    const handleFilterChange = (name, value) => {
        setActiveFilters(prev => ({
            ...prev,
            [name]: value,
        }))
        setCurrentPage(1)

        // Find the filter with that name
        const filter = filters.find(f => f.name === name)
        if (filter?.onChange) {
            filter.onChange(value)
        }
    }

    // Apply search and filters
    const filteredData = data.filter(item => {
        const matchesSearch = item.title?.toLowerCase().includes(searchQuery.toLowerCase())

        return matchesSearch
    })

    const totalPages = Math.ceil(filteredData.length / itemsPerPage)
    const startIndex = (currentPage - 1) * itemsPerPage
    const currentItems = filteredData.slice(startIndex, startIndex + itemsPerPage)

    const handlePageChange = page => {
        if (page >= 1 && page <= totalPages) setCurrentPage(page)
    }

    return (
        <div className='px-4 space-y-8 sm:px-6 lg:px-8'>
            {/* Filters Grid */}
            <div className='grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3'>
                {filters.map((filter, index) => (
                    <FormSelect
                        label={filter.label}
                        key={index}
                        placeholder={filter.placeholder}
                        value={activeFilters[filter.name] || ''}
                        options={filter.options}
                        onChange={e => handleFilterChange(filter.name, e.target.value)}
                    />
                ))}
                <div></div>
                <div></div>
                <FormInput
                    className='mt-6'
                    placeholder={t('search.title')}
                    value={searchQuery}
                    onChange={e => {
                        setSearchQuery(e.target.value)
                        setCurrentPage(1)
                    }}
                />
            </div>

            {/* Cards Grid */}
            <div className='grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3'>
                {currentItems.map((item, index) => (
                    <div key={index} className='w-full'>
                        {renderCard(item)}
                    </div>
                ))}
            </div>

            {/* Pagination */}
            <div className='flex justify-center'>
                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                />
            </div>
        </div>
    )
}

export default CardGrid
